import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUser } from '../../userContext';

import { Box, Container, Checkbox, FormControlLabel, Typography, Button} from '@mui/material';

function Terms() {
  const [checked, setChecked] = useState(false);
  const { userName, updateUserName, updateTermsAccepted, updateEulaAccepted, updateAuthenticated, updateUserId } = useUser();
  const navigate = useNavigate();
  
  const acceptTerms = async () => {
    const eulaData = {
      eula: "t",
      userName: userName,
    }
    try {
      const response = await fetch((`${process.env.REACT_APP_API}/users/eula`), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(eulaData),
      });
      const result = await response.json();
      if (result.message) {    
        updateEulaAccepted(true);
        updateAuthenticated(true);
        navigate('/alerts'); 
      } else {
        updateEulaAccepted(false);
        updateAuthenticated(false);
        toast.error('Error Occured Accepting Eula Agreement.  Please Try Again');
      }
    } catch (error) {
      console.error('Network error.  Please try again: ', error);
    }

  };

  const declineTerms = async () => {
    updateUserId(null);
    updateUserName(null); 
    updateTermsAccepted(false); 
    updateEulaAccepted(false);
    updateAuthenticated(false); 
    navigate('/');
  };

  const handleClick = (event) => {
    event.preventDefault();
    acceptTerms();
  };

  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          mt: 5,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 700,
          height: '70vh', 
          maxHeight: '70vh', 
          overflowY: 'auto', 
          backgroundColor: 'white',
          borderRadius: 1,
          boxShadow: 3,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box display="flex" width= "100%" justifyContent="flex-start">
          <Typography color= "Black" fontWeight= "Bold" variant="h5" sx={{ mb: 2 }}>
            Terms of Service
          </Typography>
        </Box>
        <Box
          sx={{
            marginTop: '-1vh',
            width: '100%',
            flexGrow: 1,
            overflow: 'hidden',
            border: '1px solid #ccc',
            borderRadius: 1,
          }}
        >
          <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
            <Viewer fileUrl="/documents/EULATermsPage.pdf" defaultScale={SpecialZoomLevel.PageWidth}/>
          </Worker>
        </Box>
        <Box display="flex" width= "100%" justifyContent="flex-start">
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
            }
              label={<span style={{ fontWeight: "Bold", color: 'Black' }}> I have read the terms and conditions of CheckMate </span>}
          />
        </Box>
        <Box display="flex" justifyContent="center" gap={2} mt={3} mb={2}>
        <Box flex={1}>
          <Button color= "error" type="submit" variant="contained" onClick={declineTerms}>
            Decline
          </Button>
        </Box>
        <Box flex={1}>
          <Button color= "success" type="submit" variant="contained" disabled={!checked} onClick={handleClick}>
            Accept
          </Button>
        </Box>        
      </Box>

      </Box>
    </Container>
  );
}

export default Terms;
